import AjaxComponentLoader from 'utils/ajax_component_loader';

export default class ActivityRepliesList {
  static getList(activityId, parentId, page = 1) {
    return AjaxComponentLoader.load({
      component: 'timeline/activity_replies_list',
      type: 'page_component',
      data: {
        activity_id: activityId,
        activity_comment_id: parentId
      },
      params: {page}
    });
  }
}
